export default __webpack_public_path__ + "static/media/CL60_SE.7e25b7b1.jpg";